import { useTranslation } from 'react-i18next';

import { IOSShare } from '../../../../../components/SVGIcons/IOSShare';
import { VerticalDots } from '../../../../../components/SVGIcons/VerticalDots';

import styles from './InAppBlockedTooltip.module.scss';

export const InAppBlockedTooltipContent = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.InAppBlockedTooltipContent}>
        <p>{t('auth.googleSignInNotSupported')}</p>
        <ul>
          <li>
            &bull;
            <b>{t('auth.ios')} </b>
            {t('auth.iosInstructions')}
            <IOSShare />
            {t('auth.inSafari')}
          </li>
          <li>
            &bull;
            <b> {t('auth.android')}</b>
            {t('auth.androidInstructions')}
            <VerticalDots />
            {t('auth.inBrowser')}
          </li>
        </ul>
      </div>
    </div>
  );
};
